<template>
  <div>
    <div class="overflow-hidden rounded-sm bg-white shadow-md w-11/12 lg:w-4/12 m-auto mb-10">
      <div class="p-5 pt-8 text-white bg-header">
        <header>
          <h1 class="text-4xl font-bold">{{pageContent.title}}</h1>
          <h2 class="font-bold">{{ pageContent.subtitle }}</h2>
        </header>
      </div>
      <div class="p-5 py-7">  
        <h3 class="text-xl text-gray-600">Activate your account.</h3>

        <!-- server message -->
        <p class="animate__animated " :class="serverMessage.err ? ['mt-4 text-pink-500 animate__headShake'] : ['mt-4 animate__rubberBand text-green-500'] " v-if="serverMessage.val" v-html="serverMessage.val"></p>

        <main>
          <form @submit.prevent="submitForm" v-if="serverMessage.err && (serverMessage.status < 500)">

            <p class="text-left mt-4 mb-2">Enter your email address to receive a new one.</p>
            <!-- email address -->
            <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
              <label :for="emailAddress.name" class="mr-2 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M20,4H4C2.897,4,2,4.897,2,6v12c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V6C22,4.897,21.103,4,20,4z M20,6v0.511 l-8,6.223L4,6.512V6H20z M4,18V9.044l7.386,5.745C11.566,14.93,11.783,15,12,15s0.434-0.07,0.614-0.211L20,9.044L20.002,18H4z"></path></svg>
              </label>
              <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="emailAddress.name"  :placeholder="emailAddress.name" v-model.trim="emailAddress.val">
            </div>
            <p class="animate__animated animate__headShake text-left text-pink-500" v-if="emailAddress.err">{{emailAddress.err}}</p>

            <button type="submit" class="overflow-hidden w-full bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-md p-2 mt-2 mb-1">Submit</button>

          </form>
        </main>
      </div>
      <div class="p-5">
        <footer>
          <h2 class="text-sm" v-html="pageContent.copyright"></h2>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { ref, computed, onMounted } from 'vue';

export default {
  name: "Activate Account",
  setup() {
    
    // vuex store
    const store = useStore();

    // vue-router
    const route = useRoute();

    const pageContent = computed(() => store.getters.pageContent );

    // onMounted
    onMounted(async () => {
      clearServerMessage();
      if(!activationCode.value.val){
        serverMessage.value.val = "Account activation failed. Activation code is required."
        serverMessage.value.err = true;
      } else {
        try {
          await store.dispatch("authModule/activateAccountForm", { activationCode : activationCode.value.val } )
          serverMessage.value.val = "Your account has been successfully activated.";
        } catch (error) {

          serverMessage.value.val = error.msg;  
          serverMessage.value.err = true;
          serverMessage.value.status = error.statusCode;

          if(error.errors){
              error.errors.forEach(element => {
                if(element.param === 'activationCode'){
                  serverMessage.value.val = element.msg;
                  serverMessage.value.err = true;
                }
              });
            }
          }
      }
    });


    // REGEX
    const REGEX = {
       EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line

    }

    // form
    const emailAddress = ref({
      name:"Email Address",
      val:"",
      err:"",
    });
    
    // form
    const activationCode = ref({
      val: route.query.code,
      err: false,
    });

    const serverMessage = ref({
      val:"",
      err: false,
      status: 0,
    })
    
    function clearForm(){
      emailAddress.value.val = "";
      serverMessage.value.val = "";

      emailAddress.value.err = "";
      serverMessage.value.err = false;
    }

      async function submitForm(){
        // clearServerMessage();
        const isReset = await resetError(); 
        if(isReset){
          const isValidated = await validateForm();
          if(isValidated){
            const form = {
              emailAddress : emailAddress.value.val,
            }
            try {
              const data = await store.dispatch("authModule/requestActivationCodeForm", form);
              clearForm();
              serverMessage.value.val = data.message;
                setTimeout(() => {
                  clearServerMessage();
              }, 5000);

            } catch (error) {

              if(error.msg){
                serverMessage.value.val = error.msg;
                serverMessage.value.err = true;
                setTimeout(() => {
                  clearServerMessage();
                }, 3000);
              } 

              if(error.errors){
                error.errors.forEach(element => {
                    serverMessage.value.val = element.msg;
                    serverMessage.value.err = true;
                });
              }
            }
          }
        }
      }

      function clearServerMessage(){
        serverMessage.value.val = "";
        serverMessage.value.err = false;
      }

      function resetError(){
        return new Promise((resolve)=>{
          emailAddress.value.err = "";
          resolve(true);
        })  
      }

       function validateForm(){
        return new Promise((resolve)=>{

          const requireStr = " is required.";
          const invalidStr = " is invalid.";

          // email address
          if(!emailAddress.value.val){
            emailAddress.value.err =  emailAddress.value.name + requireStr;
          }else if(!REGEX.EMAIL.test(emailAddress.value.val)){
            emailAddress.value.err =  emailAddress.value.name + invalidStr;
          }

          resolve(!emailAddress.value.err);

        })  
      }

    return{
      pageContent,
      serverMessage, emailAddress, activationCode,
      submitForm, clearForm,
    }
  }
}
</script>

<style lang="scss">
.password-met::after{
  content: "✔";
  @apply text-green-500 ml-2;
}
</style>
